module.exports = "/_next/static/images/apple-icon-57x57-8003cf9cc0e66cd25716f12d663538a3.png";